"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createLocationForFilters(filters) {
    const params = new URLSearchParams();
    for (const [filterType, values] of Object.entries(filters)) {
        if (values.length > 0) {
            for (const value of values) {
                params.append(filterType, value);
            }
        }
    }
    return { search: params.toString() };
}
exports.createLocationForFilters = createLocationForFilters;
function createFiltersFromLocation(location) {
    const params = new URLSearchParams(location.search);
    return {
        bodyType: params.getAll('bodyType'),
        engineType: params.getAll('engineType'),
        gearType: params.getAll('gearType'),
    };
}
exports.createFiltersFromLocation = createFiltersFromLocation;
//# sourceMappingURL=history-location.js.map